/* eslint-disable */
export enum FinnairCancelFlowType {
  RULE_24_HOUR = 'RULE_24_HOUR',
  MANUAL_REFUNDABLE = 'MANUAL_REFUNDABLE',
  INVOLUNTARY = 'INVOLUNTARY',
  INVOLUNTARY_NO_REFUND = 'INVOLUNTARY_NO_REFUND'
}

